import { ROLE_DISTRIBUTOR, ROLE_SPY } from '../../../shared/constants'

const LEGAL_DOCUMENT_FORM_MODES = {
  CREATE: 'CREATE',
  EDIT: 'EDIT',
}

const formatUserRoleName = {
  [ROLE_DISTRIBUTOR]: 'Brand Ambassador',
  [ROLE_SPY]: 'Spy',
}

export { LEGAL_DOCUMENT_FORM_MODES, formatUserRoleName }
